import { useIdleTimer } from 'react-idle-timer';
import { useUserToken } from './useToken';
import ApiService from '../services/ApiService';
import { useDispatch } from 'react-redux';
import { IN_ACTIVITY_TIMEOUT } from '../axios/constants';

export const useInActivityTracker = () => {
  const { token } = useUserToken();
  const dispatch = useDispatch();

  const onIdle = () => {
    console.log('------- onIdle -------');
    ApiService.AuthLogout().then(() => {
      localStorage.clear();
      dispatch({ type: 'RESET' });
    });
  };

  useIdleTimer({
    onIdle,
    timeout: IN_ACTIVITY_TIMEOUT,
    crossTab: true,
    leaderElection: true,
    syncTimers: 200,
    disabled: !token,
  });

  return;
};
